module.exports = __webpack_public_path__ + "img/fp5.72907cb7.jpg";